module.exports = __webpack_public_path__ + "img/(per 1000 live births) 2.38dd96e6.png";